import { DevToolsStatusBadge } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsStatusBadge';
import type { DevToolsBadgeVariant } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsStatusBadge/index.types';
import type { WebRTCConnectionStateBadgeProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/WebRTCTab/WebRTCConnectionStateBadge/index.types';
import React from 'react';

const HEALTHY_STATES = ['connected', 'completed', 'stable'];
const PENDING_STATES = [
  'connecting',
  'checking',
  'new',
  'have-local-offer',
  'have-remote-offer',
];
const BROKEN_STATES = ['disconnected', 'failed', 'closed'];

const getVariant = (state: string | null): DevToolsBadgeVariant => {
  if (!state) {
    return 'neutral';
  }
  if (HEALTHY_STATES.includes(state)) {
    return 'success';
  }
  if (PENDING_STATES.includes(state)) {
    return 'warning';
  }
  if (BROKEN_STATES.includes(state)) {
    return 'error';
  }

  return 'neutral';
};

/**
 * WebRTCConnectionStateBadge - Maps a peer connection / ICE / signaling state onto a badge variant, so the three state machines read the same way side by side.
 */
export const WebRTCConnectionStateBadge: React.FC<
  WebRTCConnectionStateBadgeProps
> = ({ state }) => (
  <DevToolsStatusBadge label={state || 'N/A'} variant={getVariant(state)} />
);
